/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

// Lets callers use `instanceof AuthBackoffError` instead of matching on the
// error message, so a backoff can be handled (e.g. shown as a distinct UI
// state) without being confused with other login failures.
export class AuthBackoffError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'AuthBackoffError';
  }
}

// Shared between authApiService.web.ts/.native.ts (where they're thrown) and
// useAuth.ts (which matches on them for error tracking), so the two stay in
// sync instead of drifting apart as separate string literals.
export const AUTH_LOGIN_BACKED_OFF_MESSAGE =
  'AuthApiService: login backed off after recent upstream failure';
export const AUTH_INVALID_RESPONSE_MESSAGE = 'Invalid authentication response';
// Dynamic suffix (status code) appended by the thrower - match on this prefix.
export const AUTH_REQUEST_FAILED_MESSAGE_PREFIX =
  'Flights authentication request failed with status';

// errorDescription labels for the three messages above - same sharing reason.
export const AUTH_LOGIN_BACKED_OFF_DESCRIPTION = 'Auth login backed off';
export const AUTH_INVALID_RESPONSE_DESCRIPTION =
  'Invalid authentication response shape';
export const AUTH_REQUEST_FAILED_DESCRIPTION = 'Flights auth request failed';
